export const formatDate = (dateString: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);

  const formattedDate = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);

  const formattedTime = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }).format(date);

  return `${formattedDate}, ${formattedTime}`;
};

export const formatDateForNote = (dateString: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);

  const formatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  const parts = formatter.formatToParts(date).reduce(
    (acc, part) => {
      acc[part.type] = part.value;
      return acc;
    },
    {} as Record<string, string>,
  );

  return `${parts.month}/${parts.day}/${parts.year}, ${parts.hour}:${parts.minute} ${parts.dayPeriod}`;
};

export const formatDateForNoteWithoutTime = (dateString: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);

  const formatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
  });

  const parts = formatter.formatToParts(date).reduce(
    (acc, part) => {
      acc[part.type] = part.value;
      return acc;
    },
    {} as Record<string, string>,
  );

  return `${parts.month} / ${parts.day} / ${parts.year}`;
};
